<template>
  <page-list
    :list="list"
    :columns="columns"
    :group-actions="groupActions"
    :single-actions="singleActions" />
</template>

<script>
import * as R from 'ramda'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'

export default {
  name: 'skuHistoryRateList',
  mixins: [WindowsMixin, ListMixin],
  props: {
    data: {
      type: Object,
      required: true,
    },
    getParams: {
      type: [Function, Object],
    },
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'billing_sku_rate_historys',
        getParams: this.getParam,
      }),
      groupActions: [
        {
          label: this.$t('op_28'),
          action: () => {
            this.createDialog('CreateSkuRateHistoryDialog', {
              title: this.$t('op_90'),
              data: [this.data],
              onManager: this.onManager,
              refresh: this.refresh,
            })
          },
          meta: () => {
            return {
              buttonType: 'primary',
            }
          },
        },
      ],
      singleActions: [
        {
          label: this.$t('op_34'),
          action: (obj) => {
            this.createDialog('UpdateSkuRateHistoryDialog', {
              title: this.$t('op_91'),
              name: this.$t('op_92'),
              data: [obj],
              columns: this.columns,
              rateData: this.data,
              onManager: this.onManager,
              refresh: this.refresh,
            })
          },
          meta: (obj) => {
            return {
              validate: obj.can_update,
            }
          },
        },
      ],
      columns: [
        {
          field: 'id',
          title: this.$t('op_93'),
        },
        {
          field: 'rate_type',
          title: this.$t('op_87'),
          formatter: _ => {
            const ret = {
              percent: this.$t('op_60'),
              amount: this.$t('op_61'),
            }
            return ret[this.data.rate_type]
          },
        },
        {
          field: 'rate',
          title: this.$t('op_69'),
          formatter: ({ row, cellValue }) => {
            const value = this.data.rate_type === 'amount' ? cellValue : cellValue * 100
            const currencyZh = this.data.currency === 'USD' ? this.$t('op_68') : this.$t('op_67')
            const unit = this.data.unit ? `/${this.data.unit}` : ''
            return `${value}${this.data.rate_type === 'amount' ? currencyZh : '%'}${unit}`
          },
        },
        {
          field: 'enabled',
          title: this.$t('op_94'),
          formatter: ({ cellValue }) => {
            return cellValue ? this.$t('op_95') : this.$t('op_96')
          },
        },
        {
          field: 'ended',
          title: this.$t('op_97'),
          formatter: ({ cellValue }) => {
            return cellValue ? this.$t('op_98') : this.$t('op_99')
          },
        },
      ],
    }
  },
  created () {
    this.list.fetchData()
  },
  methods: {
    getParam () {
      const ret = {
        ...(R.is(Function, this.getParams) ? this.getParams() : this.getParams),
      }
      return ret
    },
  },
}
</script>
